import styled, { css } from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
    ZIndex,
} from '@optimus-web/common';
import {
    StyledTransitionGroupWrapper,
    Swipeable,
    TransitionGroupChildBaseProps,
    TransitionState,
} from '@optimus-web/helpers';
import { Backdrop } from '../Backdrop';
import { IconButton, IconButtonProps } from '../IconButton';
import { Image } from '../Image';
import { Minifiable } from '../types';
import {
    BACKDROP_OPACITY,
    MAX_WRAPPER_WIDTH,
    VERTICAL_CONTAINER_WIDTH_PERCTENTAGE,
    VERTICAL_CONTAINER_WIDTH_PERCTENTAGE_SMALL,
} from './constants';

export const LightboxDialogElement = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    z-index: ${ZIndex.High};
`;

export const BackdropElement = styled(Backdrop)`
    opacity: ${BACKDROP_OPACITY};
`;

export const CloseIconButtonElement = styled(IconButton)<IconButtonProps & Minifiable>`
    position: absolute;
    z-index: ${ZIndex.Highest};
    top: ${(props) => (props.small ? getSpacingToken('100') : getSpacingToken('300'))}px;
    right: ${(props) => (props.small ? getSpacingToken('100') : getSpacingToken('300'))}px;
`;

export interface SideIconButtonElementProps extends IconButtonProps {
    right?: boolean;
}
export const SideIconButtonElement = styled(IconButton)<SideIconButtonElementProps>`
    position: absolute;
    z-index: ${ZIndex.Highest};
    width: auto;
    left: ${getSpacingToken('200')}px;
    padding: 0;

    ${(props) =>
        props.right &&
        css`
            left: auto;
            right: ${getSpacingToken('200')}px;
        `}
`;

export const LightboxWrapperElement = styled.div`
    position: relative;
    z-index: ${ZIndex.Higher};
    max-width: ${MAX_WRAPPER_WIDTH}px;
    color: ${getToken('textStaticPrimary')};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const LightboxImageWithControlsElement = styled.div<Minifiable>`
    display: flex;
    align-items: center;
    width: ${(props) =>
        props.small ? VERTICAL_CONTAINER_WIDTH_PERCTENTAGE_SMALL : VERTICAL_CONTAINER_WIDTH_PERCTENTAGE}%;
`;

export const ImageListWrapperElement = styled.div<Minifiable>`
    width: ${(props) =>
        props.small ? VERTICAL_CONTAINER_WIDTH_PERCTENTAGE_SMALL : VERTICAL_CONTAINER_WIDTH_PERCTENTAGE}%;
    max-width: 250vh;
`;

export const LightboxImageWrapperElement = styled.div<TransitionGroupChildBaseProps>`
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};
    opacity: 0;

    ${(props) => props.transitionState === TransitionState.EXITING && `opacity: 0;`}
    ${(props) => props.transitionState === TransitionState.ENTERED && `opacity: 1;`}
`;

export const LightboxTransitionGroupElement = styled(StyledTransitionGroupWrapper)`
    width: 100%;
    display: flex;
    height: 55vh;
    justify-content: center;
    align-items: center;
    position: relative;
`;

export const lightboxImageStyle = css`
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    border-radius: 4px;
    cursor: pointer;
`;

export const LightboxImageElement = styled(Image)`
    ${lightboxImageStyle}
`;

export const DescriptionWrapperElement = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${getTextTokenPreset('bodyLarge')};
    padding: ${getSpacingToken('300')}px 0;
`;

export const ImageCounterElement = styled.div`
    ${getTextTokenPreset('bodyLargeStrong')};
`;

export const ImageDescriptionElement = styled.div``;

export const LightboxSwipeableElement = styled(Swipeable)`
    width: 100%;
    display: flex;
    justify-content: center;
`;
